import { COLUMN_CODE, TableManger, TABLES } from "./TableManger";

import Table from "../services/table";

export class JobPipelineManager {
    static jobPipelines: any = {};

    static get(refresh = true): Promise<any> {
        let options = {
            colIdsToFetchRef: TableManger.getColumnId(
                TABLES.JOB_PIPELINE,
                COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S
            )
        };
        const jobPipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
        if (refresh || this.jobPipelines?.data?.length === 0) {
            return Table.getRecordsByPage(options, null, jobPipelineTableId).then(
                (res) => {
                    this.set(res);
                    return Promise.resolve(res);
                }
            );
        } else {
            return Promise.resolve(this.jobPipelines);
        }
    }

    static set(pipeline) {
        this.jobPipelines = pipeline;
    }

    static clear() {
        this.set({});
    }

    static processJobPipelineData() {
        let dataToReturn = [];
        const jobPipelineNameColId = TableManger.getColumnId(TABLES.JOB_PIPELINE, COLUMN_CODE.JOB_PIPELINE.NAME);
        const jobStageColumnId = TableManger.getColumnId(TABLES.JOB_PIPELINE, COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S);
        const jobStageNameColumnId = TableManger.getColumnId(TABLES.JOB_STAGE, COLUMN_CODE.JOB_STAGE.NAME);
        const stageDetailsKey = `${jobStageColumnId}_detail`;

        if (this.jobPipelines && this.jobPipelines.data) {
            this.jobPipelines.data.forEach((jobPipeline) => {
                let jobPipelineData = {};
                jobPipelineData["id"] = jobPipeline._id;
                jobPipelineData["name"] = jobPipeline.cells[jobPipelineNameColId];
                if (Array.isArray(jobPipeline.cells[stageDetailsKey])) {
                    jobPipelineData["stages"] = jobPipeline.cells[stageDetailsKey].map(
                        (jobStage) => {
                            return {
                                id: jobStage._id,
                                name: jobStage.cells[jobStageNameColumnId],
                            };
                        }
                    );
                }
                dataToReturn.push(jobPipelineData);
            });
        }
        return dataToReturn;
    }
}
